import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Modal, Form, Icon, Input } from 'antd'
import FormUtil from '../../utils/FormUtil'
import ForgotPasswordModal from './ForgotPasswordModal'
import SignupModal from './SignupModal'
import UserService from '../../services/UserService'
import { login } from '../../actions/UserActions'
import ErrorMessage from '../form/ErrorMessage'
import { UNEXPECTED_ERROR_MESSAGE } from '../../constants/AppConstants'
import ReactGA from 'react-ga'
import LoginFields from './LoginFields'

class LoginModal extends Component {
  state = {
    visible: false,
    errorMessage: null,
    isLoading: false
  }

  onCancel(e) {
    this.setState({ visible: false })
  }

  showLoginModal() {
    this.setState({ visible: true, errorMessage: null })
  }

  async onLogin(event) {
    const { form } = this.props
    event.preventDefault()
    const { errors, values } = await FormUtil.validateForm(form)
    if (!errors) {
      this.handleLogin(values)
    }
  }

  async handleLogin(credentials) {
    const { login } = this.props
    this.setState({ isLoading: true })
    try {
      const response = await UserService.login(credentials)
      const userDetails = response.data
      if (userDetails) {
        this.setState({ visible: false, isLoading: false })
        //dispatch logged in details
        login(userDetails)
        ReactGA.event({
          category: 'Account',
          action: 'Signin',
          label: 'Signin Success'
        })
        UserService.identifyUser(userDetails)
      } else {
        this.setState({ errorMessage: UNEXPECTED_ERROR_MESSAGE })
      }
    } catch (err) {
      this.setState({ isLoading: false })
      if (err.response && err.response.status === 401) {
        this.setState({ errorMessage: 'Invalid email or password' })
      } else {
        this.setState({ errorMessage: UNEXPECTED_ERROR_MESSAGE })
      }
      ReactGA.event({
        category: 'Account',
        action: 'Signin',
        label: 'Signin Error'
      })
    }
  }

  onForgotPassword() {
    this.onCancel()
    this.forgotPasswordComponent.showForgotPasswordModal()
  }

  onSignup() {
    this.onCancel()
    this.signupComponent.showSignupModal()
  }

  render() {
    const { visible, errorMessage, isLoading } = this.state
    return (
      <div
        onKeyPress={event => {
          if (event.key == 'Enter') return this.onLogin(event)
        }}>
        <Modal
          visible={visible}
          confirmLoading={isLoading}
          okText="SignIn"
          onOk={e => this.onLogin(e)}
          onCancel={e => this.onCancel(e)}
          destroyOnClose={true}>
          <LoginFields form={this.props.form} />
          <button className="link" onClick={() => this.onForgotPassword()}>
            Forgot password
          </button>
          <br />
          <br />
          <div className="has-text-centered">
            Not a member?&nbsp;
            <button id="signupLink" className="link signup-link" onClick={() => this.onSignup()}>
              Sign-Up!
            </button>
          </div>
          <div style={{ textAlign: 'center' }}>
            <ErrorMessage errorMessage={errorMessage} />
          </div>
        </Modal>
        <ForgotPasswordModal wrappedComponentRef={c => (this.forgotPasswordComponent = c)} />
        <SignupModal wrappedComponentRef={c => (this.signupComponent = c)} />
      </div>
    )
  }
}

const WrappedLoginModal = Form.create()(LoginModal)
const mapStateToProps = (state, ownProps) => ({ userState: state.user })
export default connect(mapStateToProps, {
  login
})(WrappedLoginModal)



// WEBPACK FOOTER //
// ./src/components/login/LoginModal.js